// extracted by mini-css-extract-plugin
module.exports = {"mainParagraph":"nepal_team_mainParagraph__1kv6h"};